<template>
  <div class="page-business">
    <!-- 品牌设计 -->
    <SRF>
      <Brand ref="brand" :data="brandData" />
    </SRF>
    <!-- 合作流程 -->
    <SRF>
      <Step />
    </SRF>
    <!-- APP开发 -->
    <SRF>
      <AppDev ref="app" :data="appDevData" />
    </SRF>
    <!-- web开发 -->
    <SRF>
      <WebDev ref="web" :data="webDevData" />
    </SRF>
    <!-- 微信开发 -->
    <SRF>
      <WxDev ref="wx" :data="wxDevData" />
    </SRF>
    <!-- 系统开发 -->
    <SRF>
      <SysDev ref="sys" :data="sysDevData" />
    </SRF>
    <!-- 人员配置 -->
    <SRF>
      <PersonConfig :data="personConfigData" />
    </SRF>
    <!-- 底部footer -->
    <Footer />
  </div>
</template>

<script>
import utils from "@/api/Utils";
import Brand from "./components/Brand";
import Step from "./components/Step";
import AppDev from "./components/AppDev";
import WebDev from "./components/WebDev";
import WxDev from "./components/WxDev";
import SysDev from "./components/SysDev";
import PersonConfig from "./components/PersonConfig";
import Footer from "@/components/Footer";
import { pageApi } from "@/api";
export default {
  components: {
    Brand,
    Step,
    AppDev,
    WebDev,
    WxDev,
    SysDev,
    PersonConfig,
    Footer,
  },

  name: "business",
  data() {
    return {
      brandData: {},
      appDevData: {},
      webDevData: {},
      wxDevData: {},
      sysDevData: {},
      personConfigData: {},
    };
  },
  mounted() {
    this.getBusinessList();
    setTimeout(() => {
      let type = this.$route.query.type;
      if (type !== undefined) {
        const components = {
          0: "brand",
          1: "sys",
          2: "web",
          3: "wx",
          4: "app",
        };
        const targetRef = components[type];
        if (targetRef && this.$refs[targetRef]) {
          const element = this.$refs[targetRef];
          const elementRect = element.$el.getBoundingClientRect();
          const elementTop = elementRect.top + window.pageYOffset;
          const windowHeight = window.innerHeight;
          const scrollTo =
            elementTop - windowHeight / 2 + elementRect.height / 2;
          window.scrollTo({
            top: scrollTo,
            behavior: "smooth",
          });
        }
      }
    }, 500);
  },
  methods: {
    async getBusinessList() {
      const res = await pageApi.getBusinessList();
      const listData = res.result;
      this.brandData = listData.find((item) => item.title === "品牌设计");
      this.appDevData = listData.find((item) => item.title === "APP开发");
      this.webDevData = listData.find(
        (item) => item.title === "高端网站定制开发"
      );
      this.wxDevData = listData.find((item) => item.title === "微信平台开发");
      this.sysDevData = listData.find((item) => item.title === "系统开发");
      this.personConfigData = listData.find(
        (item) => item.title === "人力资源配置"
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import url("./index.scss");
</style>
